module.exports = __webpack_public_path__ + "img/cate3.219afb60.png";